export default function (juizo) {
  let window, title
  if (typeof juizo !== 'undefined' && juizo) {
    window = juizo.id ? `juizo.${juizo.id}` : 'juizo.new'
    title = 'Visualizar Juízo'
  } else {
    window = 'juizo.new'
    title = 'Novo Juízo'
  }

  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: title,
    width: '500',
    height: '60%',
    minWidth: '500px',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      id: juizo?.id
    }
  }, () => import('./Juizo'))
      .then((wid) => {
        console.log(wid)
        this.$uloc.window.listen(wid, {
          update: (wid, val) => {
            console.log('Atualizado: ', val)
            this.updateList(val)
          }
        })
      }) // return wid
}
